// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { cookiePrivacyPolicyPopupStyles } from "@vanmeter/Overrides/Components/CookiePrivacyPolicyPopup";
import { hideElementOnPrint, xScreen } from "@vanmeter/XDL/Utilities";
import { css } from "styled-components";

cookiePrivacyPolicyPopupStyles.drawer = {
    position: "bottom",
    size: 100,
    cssOverrides: {
        drawerTitle: css`
            display: none;
        `,
        drawerContent: css`
            display: flex;
            padding: 16px;
            margin: 0 auto;
            width: 100%;
        `,
        drawerBody: css`
            justify-content: center;
            width: 100%;
            padding: 0;
            ${hideElementOnPrint}

            ${xScreen("lt", "md")} {
                && {
                    display: flex;
                }
            }

            ${xScreen("lt", "sm")} {
                && {
                    top: auto;
                    bottom: 0;
                    height: 148px;
                }
            }
        `,
        scrim: css`
            top: auto;
            bottom: 0;
            ${xScreen("lt", "sm")} {
                height: 148px;
                width: 100vw;
            }
        `,
    },
    closeButtonProps: {
        css: css`
            display: none;
        `,
    },
    enableClickThrough: true,
};

cookiePrivacyPolicyPopupStyles.container = {
    css: css`
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 10px;
        flex: 1;
        ${xScreen("lt", "sm")} {
            flex-direction: column;
            align-items: unset;
        }
    `,
};

cookiePrivacyPolicyPopupStyles.buttonsWrapper = {
    css: css`
        display: flex;
        gap: 10px;
        ${xScreen("lt", "sm")} {
            flex-direction: column-reverse;
        }
    `,
};

cookiePrivacyPolicyPopupStyles.closeButton = {
    variant: "tertiary",
    css: css`
        width: 100%;
    `,
};

cookiePrivacyPolicyPopupStyles.acceptButton = {
    css: css`
        white-space: nowrap;
    `,
};
